<template>
    <div class="animated fadeIn">
      <div class="title font-300 font-24 mb-15">
        {{this.$route.name}}
      </div>
      <div class="box">
        <div class="p-15 pb-0">
          <div class="row">
            <div class="col-sm-4">
              <table>
                <tr>
                  <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                  <td>
                    <flat-pickr @on-change="onChange" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                  </td>
                </tr>
              </table>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-4 col-form-label text-right">
                  Branch
                </div>
                <div class="col-sm-8">
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </div>
              </div>
            </div>
            <div class="col-sm-4 text-right">
              <div class="search-header">
                <div class="custom-search-container">
                  <div class="input-group custom-search">
                    <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                    <span class="icon-magnifier icon-input-custom"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mb-0">
        <div class="p-15 pt-0">
          <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template v-slot:cell(form_type)="data">
              Merchandise
            </template>
            <template v-slot:cell(name)="data">
              <template v-if="data.item.member">
                {{data.item.member.first_name}} {{data.item.member.last_name}}
              </template>
            </template>
            <template v-slot:cell(date)="data">
              {{parseDate(data.item.created_at)}}
            </template>
            <template v-slot:cell(time)="data">
              {{parseTime(data.item.created_at)}}
            </template>
             <template v-slot:cell(amount)="data">
              {{parseCurrency(data.item.amount)}}
            </template>
            <template v-slot:cell(action)="data">
              <b-button size="sm" @click="editForm('/allForm/editGrabAndGo?id=' + data.item.id)" class="btn-table warning mr-1">
              <i class="far fa-edit"></i> Edit
              </b-button>
              <b-button size="sm" v-on:click="deleteForm(data.item.id)" class="btn-table danger">
                <i class="fas fa-times"></i> Delete
              </b-button>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
              :total-pages="totalPage"
              @page-changed="pageOneChanged"
              prev-text="Prev" next-text="Next"/>
        </div>
      </div>

      <div v-if="loadingActive == true" class="loading-container">
        <div class="wrap-screen w-100 h-100">
          <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
          <div class="title-loading color-white">Loading...</div>
        </div>
      </div>

    </div>
  </template>

  <script>
  import { Callout } from '@coreui/vue'
  import moment from 'moment'
  import axios from 'axios'
  import { Auth } from '@/api'
  import Pagination from '@/views/component/pagination'

  export default {
    name: 'allForm',
    components: {
      'app-pagination': Pagination
    },
    props: {
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: true
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        loadingActive: false,
        fields: [
          {
            key: 'member_id',
            label: 'Member ID',
            sortable: false
          },
          {
            key: 'club',
            label: 'Club Branch',
            sortable: false
          },
          {
            key: 'member_name',
            label: 'Member Name',
            sortable: false
          },
          {
            key: 'membership_advisor',
            label: 'Membership Advisor',
            sortable: false
          },
          {
            key: 'membership',
            label: 'Type Membership',
            sortable: false
          },
          {
            key: 'email',
            label: 'Email',
            sortable: false
          },
          {
            key: 'phone_number',
            label: 'No Hp',
            sortable: false
          },
          {
            key: 'voucher_no',
            label: 'Kode Voucher',
            sortable: false
          },
          {
            key: 'voucher_type',
            label: 'Voucher Type',
            sortable: false
          },
          {
            key: 'redeem_at',
            label: 'Date Input Voucher',
            sortable: false
          },
          {
            key: 'used_at',
            label: 'Date Used Voucher',
            sortable: false
          },
          {
            key: 'expired_at',
            label: 'Expired Voucher',
            sortable: false
          },
          {
            key: 'customer_service',
            label: 'Customer Service',
            sortable: false
          },
        ],
        items: [],
        dataBranch: [],
        branch_id: null,
        getId: Auth.Session.get().paradigm_id,
        exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
        exportConfig: {
          mode: "range",
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: "d/m/y",
          defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
        },
        sortType: '',
        sortBy: '',
        searchData: '',
        currentPage: 1,
        paginationLimit: 10,
        totalPage: 0
      }
    },
    computed: {
      name () {
        return this.$route.name
      }
    },
    methods: {
      onChange(selectedDates, dateStr, instance) {
        // console.log('test2', dateStr)
        if(selectedDates.length === 2){
            if(typeof selectedDates[0] === typeof selectedDates[1]){
                this.exportDates = dateStr + ' to ' + dateStr
            }else{
                this.exportDates = dateStr
            }
            if(this.exportDates.includes(" to ") === true) {
                this.fetchData()
            }
        }
      },
      exportReport() {
        this.loadingActive = true
        let dates = this.exportDates.split(' to ')
        let url = 'crm/v1/export/form_report/report_member_voucher?start_date='+dates[0]+'&end_date='+dates[1]+ '&product_type_id=2'

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }

        axios({
          method: 'get',
          url: url,
          responseType: 'arraybuffer'
        }).then(response => {
          this.loadingActive = false
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Member Voucher '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
          link.click()
        }).catch(error => {
          this.loadingActive = false
          console.log('error', error)
        })
      },
      parseDate (value) {
        moment.locale('en')
        return moment(value).format('DD MMMM YYYY')
      },
      parseTime (value) {
        moment.locale('en')
        return moment(value).format('h:mm a')
      },
      pageOneChanged (pageNum) {
        this.currentPage = pageNum
        this.fetchData()
      },
      parseCurrency(event) {
        var data = parseInt(event)
        return 'Rp. ' + data.toLocaleString('id-ID', {maximumFractionDigits:0})
      },
      sortingChanged (event) {
        // console.log(event.sortDesc)
        // event.sortBy   ==> Field key for sorting by (or null for no sorting)
        // event.sortDesc ==> true if sorting descending, false otherwise
        this.sortBy = event.sortBy
        if (event.sortDesc === false) {
          this.sortType = 'asc'
          // console.log(this.sortType)
        } else {
          this.sortType = 'desc'
          // console.log(this.sortType)
        }
        this.fetchData()
      },
      enterClicked (searchEvent) {
        this.fetchData()
      },
      getBadge (status) {
        return status === 'Active' ? 'success'
          : status === 'Inactive' ? 'danger'
            : status === 'active' ? 'success'
              : status === 'inactive' ? 'danger' : 'primary'
      },
      getRowCount (items) {
        return items.length
      },
      openPage (event) {
        this.$router.push(event)
      },
      editForm (event) {
        this.$router.push(event)
      },
      showModal (id) {
        this.$refs[id].show()
      },
      changeBranch(event) {
        if (event != null) {
          this.branch_id = event
        }
        this.fetchData()
      },
      deleteForm(event) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: true,
          showLoaderOnConfirm: false
        }).then((result) => {
          if(result.value) {
            this.$swal('Deleted', 'You successfully deleted this file', 'success')
            axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
            // axios.delete('fitness/v1/form/'.concat(event)).then(response => {
            //   // this.$router.go()
            //   this.fetchData()
            // }).catch(error => {
            //   console.log('error', error)
            // })
            axios.delete('crm/v1/form_grab_and_go/delete/'.concat(event)).then(response => {
              // this.$router.go()
              this.fetchData()
            }).catch(error => {
              console.log('error', error)
            })
          } else {
            this.$swal('Cancelled', 'Your file is still intact', 'info')
          }
        })
      },
      fetchData() {
        this.loadingActive = true
        let dates1 = this.exportDates.split(' to ')
        axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
        let url = 'crm/v1/report_member_voucher?page=' + this.currentPage
          + '&limit=' + this.paginationLimit
          + '&sorting=' + this.sortBy
          + '&sorting_type=' + this.sortType
          + '&keyword=' + this.searchData
          + '&start_date=' + dates1[0]
          + '&end_date=' + dates1[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }

        axios.get(url).then(response => {
            this.loadingActive = false
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
        }).catch(error => {
          this.loadingActive = false
          console.log('error', error)
        })

        axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    created () {
      this.fetchData()
    }
  }
  </script>

  <style>
  </style>
